export function leftPad(num, size) {
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
}

/**
 * Gibt den String mit dem ersten Buchstaben als Großbuchstaben zurück
 * @param string der String, dessen erster Buchstabe ein Großbuchstabe sein soll
 * @returns {string}
 */
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
